import { render } from "./ExpandableIcon.vue?vue&type=template&id=63226d4a&scoped=true&ts=true"
import script from "./ExpandableIcon.vue?vue&type=script&lang=ts"
export * from "./ExpandableIcon.vue?vue&type=script&lang=ts"

import "./ExpandableIcon.vue?vue&type=style&index=0&id=63226d4a&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63226d4a"]])

export default __exports__